import { initializeApp } from "firebase/app";
import store from "./Store"
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { notification } from "antd";
import { BellOutlined } from "@ant-design/icons";

const firebaseConfig = {
  apiKey: "AIzaSyD5XAuoIARIY9HPpIOLWGXbbEZPgT7HVuE",
  authDomain: "sng-firebase-ca4a5.firebaseapp.com",
  projectId: "sng-firebase-ca4a5",
  storageBucket: "sng-firebase-ca4a5.appspot.com",
  messagingSenderId: "331532254538",
  appId: "1:331532254538:web:a21ac45a1c5225237e95b3",
  measurementId: "G-SJLBE8X39F",
};
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const generateToken = async () => {
  const serviceWorkerRegistration = await navigator.serviceWorker.register(
    `/firebase-messaging-sw.js`
  );
  return getToken(messaging, {
    vapidKey:
      "BASK7D4M12S0BQ_AdWKcU30sMphkUsS8C3SIXVCB4E5Qclmqr3YDBFQAbpTjU8E5VkgpEYxSubGCbLLxIShZVfQ",
    serviceWorkerRegistration,
  })
    .then((currentToken) => {
      if (currentToken) {
        return currentToken;
      } else {
      }
    })
    .catch((err) => {
    });
};

const incrementNotificationCount = () => ({
  type: "INCREMENT_NOTIFICATION_COUNT"
});
onMessage(messaging, (payload) => {
  store.dispatch(incrementNotificationCount());
  notification.info({
    message: payload.notification.title,
    description: payload.notification.body,
    placement: "bottomRight",
    icon: <BellOutlined style={{ color: "#284F68" }} />,
    style: { background: "#F0FFFF" },
  });
});
export default generateToken;
